import {LeaderboardExportTable} from './buildLeaderboardExportTable';

// UTF-8 byte-order mark so Excel renders accented/Czech characters correctly.
const BOM = '﻿';
// Semicolon delimiter — the Excel-friendly default for CZ/EU locales.
const DELIMITER = ';';
const LINE_ENDING = '\r\n';
// A field is quoted only when it contains the delimiter, a quote, a line break
// or a space; embedded quotes are doubled. Standard, Excel-compatible CSV.
const NEEDS_QUOTING = /[;"\r\n ]/;

const escapeCell = (value: string) =>
  NEEDS_QUOTING.test(value) ? `"${value.replaceAll('"', '""')}"` : value;

const toCsvLine = (cells: string[]) => cells.map(escapeCell).join(DELIMITER);

/**
 * Serializes the leaderboard export table to a CSV string, generated entirely
 * client-side (no backend round-trip): UTF-8 BOM, semicolon delimiter, quoted
 * fields where needed, CRLF line endings.
 */
export const buildLeaderboardCsv = (table: LeaderboardExportTable): string => {
  const lines = [table.columns, ...table.rows.map((row) => row.cells)].map(toCsvLine);

  return `${BOM}${lines.join(LINE_ENDING)}`;
};
